<div class="tabcontrol">
  <button
    #tabButton
    class="tab-header-item"
    (click)="setActiveTab(item.index)"
    *ngFor="let item of steps"
    [ngClass]="item.index === activeStep ? 'active' : ''"
  >
    {{ item.label }}
  </button>
</div>
<ng-content class="w100"></ng-content>
